import { Link } from 'react-router-dom';
import {
  ShieldFillCheck,
  MegaphoneFill,
  CalendarEventFill,
  TicketDetailedFill,
  GearFill,
  PersonBadgeFill,
  CurrencyDollar,
  JournalText,
  ClipboardDataFill,
} from 'react-bootstrap-icons';

const LOGS_ENABLED = process.env.REACT_APP_ENABLE_STAFF_LOGS === 'true';

const STAFF_AREAS = [
  {
    to: '/staff/announcements',
    icon: <MegaphoneFill />,
    title: 'Announcements',
    desc: 'Post and manage server announcements.',
  },
  {
    to: '/staff/events',
    icon: <CalendarEventFill />,
    title: 'Event Schedule',
    desc: 'Create and manage scheduled server events.',
  },
  {
    to: '/staff/tickets',
    icon: <TicketDetailedFill />,
    title: 'Support Tickets',
    desc: 'View and respond to player support tickets.',
  },
  {
    to: '/staff/settings',
    icon: <GearFill />,
    title: 'Site Settings',
    desc: 'Configure server and website settings.',
  },
  {
    to: '/staff/creators',
    icon: <PersonBadgeFill />,
    title: 'Creator Codes',
    desc: 'Manage creator codes and revenue sharing.',
  },
  {
    to: '/staff/packages',
    icon: <CurrencyDollar />,
    title: 'Coin Packages',
    desc: 'Configure purchasable coin packages.',
  },
  {
    to: '/staff/guides',
    icon: <JournalText />,
    title: 'Guide Editor',
    desc: 'Create and edit player guide content.',
  },
  ...(LOGS_ENABLED ? [{
    to: '/staff/logs',
    icon: <ClipboardDataFill />,
    title: 'Player Logs',
    desc: 'Browse login, chat, item, trade, and vending logs.',
  }] : []),
];

export function StaffPanel() {
  return (
    <div className="sp-page">
      <div className="sp-hero">
        <div className="sp-hero-icon"><ShieldFillCheck /></div>
        <h2>Staff Panel</h2>
        <p>Manage server content and settings.</p>
      </div>

      <div className="sp-grid">
        {STAFF_AREAS.map(area => (
          <Link key={area.to} to={area.to} className="sp-card">
            <span className="sp-card-icon">{area.icon}</span>
            <p className="sp-card-title">{area.title}</p>
            <p className="sp-card-desc">{area.desc}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
